import { Theme } from "@mui/material/styles";
import { CSSObject } from "tss-react/types";

export type InputAdormentClassKeys =
    | "root"
    | "container"
    | "paper"
    | "inputRoot"
    | "inputInput"
    | "divider"
    | "loadMore"
    ;

export const InputAdormentClasses = (theme: Theme): Record<InputAdormentClassKeys, CSSObject> => ({
    root: {
        width: "100%",
        marginTop: theme.spacing(1),
        marginBottom: "4px"
    },

    container: {
        position: 'relative',
    },

    paper: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing(),
        left: 0,
        right: 0,
    },

    inputRoot: {
        color: 'inherit',
        flexWrap: 'wrap',
    },

    inputInput: {
        width: "auto",
        flexGrow: 1
    },

    divider: {
        height: theme.spacing(2),
    },

    loadMore: {
        fontSize: theme.typography.caption.fontSize,
        color: theme.typography.caption.color
    }
});
